import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Formik, Form } from 'formik';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Input from '../../../components/Input';
import Button from '../../../components/Button';

import { recoverPassword } from '../store/thunk';

import { validations } from './validations';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';
import { useStyles } from '../../Login/components/styles';

const logoJumpPark = require('../../../assets/img/logo_login.svg');
const logoJumpCar = require('../../../assets/img/logo_login_jump_car.svg');
const backgroundJumpPark = require('../../../assets/img/login_background.png');
const backgroundJumpCar = require('../../../assets/img/login_background_jump_car.png');

export default function PasswordRecovery() {
  const classes = useStyles();

  const { width, height } = useWindowDimensions();
  const isMobile = width < 960;

  const dispatch = useDispatch();

  const { isLoading } = useSelector(state => state.profile);

  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isEmailRegistered, setIsEmailRegistered] = useState(true);

  const initialState = {
    email: ''
  }

  const isJumpPark =
    window.location.hostname == 'localhost' ||
    window.location.hostname == 'teste-admin.jumppark.com.br' ||
    window.location.hostname == 'admin.jumppark.com.br';

  useEffect(() => {
    if(isEmailSent) {
      const timeout = setTimeout(() => setIsEmailSent(false), 60000);
      return () => clearTimeout(timeout);
    }
  }, [isEmailSent]);

  const handlePasswordRecovery = async (values, actions) => {
    const { resetForm } = actions;

    return dispatch(recoverPassword(values))
      .then(() => {
        resetForm();
        setIsEmailRegistered(true);
        setIsEmailSent(true);
      })
      .catch(() => {
        setIsEmailRegistered(false);
      });
  }

  const getSloganTop = () => {
    if(height < 600) {
      return '15%';
    }

    if(height < 700) {
      return '30%';
    }

    if(height < 850) {
      return '40%';
    }

    return '50%';
  }

  return(
    <Grid container className={classes.wrapper}>
      {!isMobile && (
        <div
          style={{ top: getSloganTop() }}
          className={classes.slogan}
        >
          <Typography variant="h5">
            {isJumpPark ? (
              <b>Controle o hoje, conquiste o <br /> amanhã_</b>
            ) : (
              <b>Alcance resultados, supere <br /> expectativas_</b>
            )}
          </Typography>
          <div className={classes.sloganVerticalAdornment} />
          <div className={classes.sloganHorizontalAdornment} />
        </div>
      )}
      <Grid
        item
        md={6}
        xs={12}
        style={{ backgroundImage: `url(${isJumpPark ? backgroundJumpPark : backgroundJumpCar})` }}
        className={[classes.containerBackground, isMobile ? classes.halfVh : classes.fullVh]}
      >
        <Grid className={isJumpPark ? classes.containerBackgroundJumpParkGradient : classes.containerBackgroundJumpCarGradient} />
      </Grid>
      {!isMobile && (
        <Grid
          item
          md={3}
          xs={12}
          className={[classes.containerSecondary, isMobile ? classes.halfVh : classes.fullVh]}
        >
          <Typography
            color="#212121"
            variant="h5"
            style={{ whiteSpace: 'nowrap' }}
            className={classes.containerFloatingComponent}
          >
            Juntos nós podemos
          </Typography>
        </Grid>
      )}
      <Grid
        item
        md={3}
        xs={12}
        className={[classes.containerLogin, !isMobile && classes.fullVh]}
      >
        <div className={isMobile && classes.containerFormAndSloganMobile}>
          <div
            className={isMobile ? classes.containerFormMobile : classes.containerForm}
            style={{ padding: 30 }}
          >
            <img
              alt="Jump Park"
              src={isJumpPark ? logoJumpPark : logoJumpCar}
              className={classes.logo}
            />
            <Formik
              enableReinitialize
              initialValues={initialState}
              validationSchema={validations}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={handlePasswordRecovery}
            >
              {({ ...formikProps }) => (
                <Form>
                  {isEmailSent && (
                    <Typography variant='h6' style={{ marginBottom: 20 }}>
                      Enviamos o processo de recuperação <br /> de senha para seu e-mail.
                    </Typography>
                  )}
                  {isEmailSent && (
                    <Typography variant='body1' style={{ marginBottom: 20 }}>
                      Recebeu? Aguarde 60 segundos para reenviar.
                    </Typography>
                  )}
                  {!isEmailSent && (
                    <Typography variant='h6' style={{ marginBottom: 20 }}>
                      Digite seu e-mail e acesse seu <br /> email para recuperar a senha.
                    </Typography>
                  )}
                  {!isEmailSent && (
                    <Input
                      name="email"
                      type="email"
                      label="Seu e-mail"
                      value={formikProps.values.email}
                      error={formikProps.errors.email || !isEmailRegistered}
                      helperText={formikProps.errors.email || (!isEmailRegistered && 'Este e-mail não está cadastrado no sistema')}
                      onChange={formikProps.handleChange}
                    />
                  )}
                  <Button
                    fullWidth
                    verticalGutter
                    loading={isLoading}
                    disabled={isEmailSent}
                    type="submit"
                    color="success"
                  >
                    Recuperar Senha
                  </Button>
                  <Typography
                    to="/"
                    variant="body1"
                    color="textSecondary"
                    component={Link}
                  >
                    Voltar
                  </Typography>
                </Form>
              )}
            </Formik>
            <Grid>
              {isMobile && (
                <Typography color="textSecondary" style={{ margin: '30px 0 30px 0' }}>
                  <b>Juntos nós podemos</b>
                </Typography>
              )}
            </Grid>
          </div>
          {isMobile && (
            <div className={classes.sloganMobile}>
              <Typography variant="h5">
                {isJumpPark ? (
                  <b>Controle o hoje, conquiste o <br /> amanhã_</b>
                ) : (
                  <b>Alcance resultados, supere <br /> expectativas_</b>
                )}
              </Typography>
            </div>
          )}
        </div>
      </Grid>
    </Grid>
  );
}